/** @file TILE_EDGES: the four tile edges, their outward normals, corners and partners (design 21.6). */

/** A tile edge in image space (y down). */
export type TileEdge = 'top' | 'bottom' | 'left' | 'right';

/** What corners and the cut read per edge. */
export type TileEdgeInfo = {
  /** Outward normal as an image angle (degrees from image-down, counter-clockwise: 0 bottom, 90 right). */
  normalDeg: number;
  /** The edge's two corners in `[tl, tr, br, bl]` order, and the corner across the tile from each. */
  corners: [number, number];
  partners: [number, number];
  /** Image axis perpendicular to the edge (0 x: left/right, 1 y: top/bottom); the tile extent T runs along it. */
  axis: 0 | 1;
  /** The edge lies at the tile size on that axis (bottom, right), else at 0. */
  far: boolean;
  opposite: TileEdge;
};

/** The edge table; `normalDeg` is also the cut line direction (`cutAngle`) when that edge is cut. */
export const TILE_EDGES: Readonly<Record<TileEdge, TileEdgeInfo>> = {
  bottom: { normalDeg: 0, corners: [2, 3], partners: [1, 0], axis: 1, far: true, opposite: 'top' },
  right: { normalDeg: 90, corners: [1, 2], partners: [0, 3], axis: 0, far: true, opposite: 'left' },
  top: { normalDeg: 180, corners: [0, 1], partners: [3, 2], axis: 1, far: false, opposite: 'bottom' },
  left: { normalDeg: 270, corners: [0, 3], partners: [1, 2], axis: 0, far: false, opposite: 'right' },
};
